import { render, staticRenderFns } from "./SocialPostWordCount.vue?vue&type=template&id=5b7802cf&"
import script from "./SocialPostWordCount.vue?vue&type=script&lang=js&"
export * from "./SocialPostWordCount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports